<script>
    import 'leaflet/dist/leaflet.css'
    import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css';

    // import axios from "axios";
    import Camera from '@components/camera.vue'
    import { LMap, LTileLayer, LMarker, LIcon, LFeatureGroup } from 'vue2-leaflet'
    import 'leaflet-defaulticon-compatibility';

    export default {
        components: { Camera, LMap, LTileLayer, LMarker, LIcon, LFeatureGroup },
        props: {
            site: {
                type: Object,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
          expanded: {
            type: Boolean,
            default: false
          },
          showProtocolLink: {
              type: Boolean,
              default: false
          }
        },
        data() {
            return {
                cameras: [],
                view: 'list',
                tileLayerUrl: 'https://api.tiles.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoiYm91cmJhc3F1ZXRrIiwiYSI6ImNqeTQ2MXY2MjB5bWszY3E4cmNxczZ2bDIifQ.4gHcYgmwYH9aJQQ5N0Hfyw',
                mapOptions: {
                    attributionControl: false,
                },
                loading: false,
                loadingColor: this.$style['color-primary'],
                loadingSize: '30px',
                message: '',
                show: this.expanded
            }
        },
        computed: {
            sortedCameras: function() {
                function compare(a, b) {
                    if (a.name < b.name) {
                        return -1;
                    }

                    if (a.name > b.name) {
                        return 1;
                    }

                    return 0;
                }

                return this.cameras.slice(0).sort(compare);
            },
            viewListClass: function() {
                const classes = [
                    this.$style.listView,
                    (this.view === 'list') ? this.$style.active : '',
                ];

                return classes;
            },
            viewMapClass: function() {
                const classes = [
                    this.$style.mapView,
                    (this.view === 'map') ? this.$style.active : '',
                ];

                return classes;
            },
            containerListClass: function() {
                const classes = [
                    this.$style.listContainer,
                    (this.view === 'list') ? this.$style.active : this.$style.hidden,
                ];

                return classes;
            },
            containerMapClass: function() {
                const classes = [
                    this.$style.mapContainer,
                    (this.view === 'map') ? this.$style.active : this.$style.hidden,
                ];

                return classes;
            },
            showTopHr: function(){
                return this.index > 0;
            }
        },
        methods: {
            visibilityChanged (isVisible) {
                if (isVisible) {
                    if (this.site.systems.length > 0) {
                      this.cameras = this.site.systems;

                    } else {
                        this.loading = false
                        this.message = 'No cameras found for this location.'
                    }
                }
            },
            setMapView: function() {
                this.view = 'map'

                this.$refs.leafmap.mapObject.fitBounds(this.$refs.leafmapMarkers.mapObject.getBounds(), {padding: [30, 30]})
            },
            markerClass: function(cameraId) {
                const classes = [
                    this.$style.marker,
                    (parseInt(this.$route.params.id) === parseInt(cameraId)) ? this.$style.active : '',
                ];

                return classes;
            },
          toggleShow: function () {
              this.show = !this.show;
          }
        },
    }
</script>

<template>
    <div v-observe-visibility="{ callback: visibilityChanged, once: true }" :class="$style.site">
        <BaseHr v-if="showTopHr"></BaseHr>
        <header>
            <div :class="$style.headerLeft">
                <h2>{{ site.name }}</h2>
            </div>
            <div :class="$style.headerRight">
                <BaseLink v-if="showProtocolLink" name="protocol" :params="{ siteId: site.uuid }" :class="[$style.button, 'mr-4']">Site info & protocol</BaseLink>
                <span :class="viewListClass.join(' ')" @click="view = 'list'"><svg width="24" height="24" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.613 16.388h14.775v-4.32H1.613v4.32zm-.001-10.59h14.775V1.611H1.612v4.185zm0 5.463h14.776V6.603H1.613v4.658zM17.195 0H.806A.806.806 0 000 .806v16.388c0 .445.36.806.806.806h16.388a.807.807 0 00.806-.806V.806A.807.807 0 0017.194 0z" fill="currentColor" fill-rule="evenodd"/></svg><span>List</span></span>
                <span :class="viewMapClass.join(' ')" @click="setMapView"><svg width="24" height="24" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9 0c4.962 0 9 4.037 9 9s-4.038 9-9 9c-4.963 0-9-4.037-9-9s4.037-9 9-9zm0 1.516C4.873 1.516 1.516 4.873 1.516 9S4.873 16.484 9 16.484 16.484 13.127 16.484 9 13.127 1.516 9 1.516zm3.972 3.512c.14.14.194.342.148.53l-.032.093-2.167 4.98a.56.56 0 01-.215.252l-.075.04-4.976 2.167a.564.564 0 01-.773-.648l.03-.092 2.16-4.968V7.38l.005-.012a.56.56 0 01.217-.252l.074-.04 4.98-2.166a.563.563 0 01.624.118zM7.78 8.575l-1.266 2.912 2.91-1.267L7.78 8.575zm3.707-2.063L8.576 7.78l1.644 1.644 1.267-2.91z" fill="currentColor"/></svg><span>Map</span></span>
            </div>
        </header>
      <button v-if="!show" type="button" @click="toggleShow" class="btn btn-red">Show</button>
        <div v-if="show" :class="containerListClass.join(' ')">
            <ClipLoader :loading="loading" :color="loadingColor" :size="loadingSize"></ClipLoader>
            <div v-if="message" :class="$style.message">{{ message }}</div>
            <Camera v-for="camera in sortedCameras" :key="'camera_'  + camera.uuid" :camera="camera"></Camera>
        </div>
        <div :class="containerMapClass.join(' ')">
            <LMap ref="leafmap" :class="$style.map" :options="mapOptions">
                <LTileLayer :url="tileLayerUrl"></LTileLayer>
                <LFeatureGroup ref="leafmapMarkers">
                    <LMarker v-for="camera in cameras" :key="'marker_'  + camera.uuid" :lat-lng="[camera.latitude, camera.longitude]">
                        <LIcon :icon-size="[190, 37]" :icon-anchor="[18, 18]">
                            <BaseLink name="camera" :params="{ id: camera.uuid }" :class="markerClass(camera.uuid).join(' ')">
                                <span :class="$style.markerIcon"><svg width="24" height="24" viewBox="0 0 22 15" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.128 0c1.026 0 1.862.803 1.862 1.791V3.57l3.664-1.752a.967.967 0 01.905.041.887.887 0 01.441.761v9.758c0 .31-.167.598-.441.762a.965.965 0 01-.905.04l-3.664-1.753v1.782c0 .988-.836 1.791-1.862 1.791H1.862C.836 15 0 14.197 0 13.209V1.791C0 .803.836 0 1.862 0zm0 1.791H1.862v11.418H15.13v-2.905a.854.854 0 01-.09-.365V5.058c0-.129.036-.25.09-.364l-.002-2.903zM12.13 9.474c.502 0 .908.353.908.79 0 .436-.406.789-.908.789H4.982c-.502 0-.908-.353-.908-.79 0-.436.406-.79.908-.79zm8.009-5.408L16.99 5.57v3.856l3.148 1.507V4.066z" fill="currentColor"/></svg></span>
                                <span :class="$style.markerText">{{ camera.name }} <svg width="24" height="24" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1.747.301A1.019 1.019 0 00.3.301a1.03 1.03 0 000 1.453L4.53 6 .3 10.246A1.03 1.03 0 001.023 12c.262 0 .524-.1.724-.301L6.7 6.726a1.033 1.033 0 000-1.452L1.747.3z" fill="currentColor"/></svg></span>
                            </BaseLink>
                        </LIcon>
                    </LMarker>
                </LFeatureGroup>
            </LMap>
        </div>
    </div>
</template>


<style lang="scss" module>
    @import '@design';

    .site {
        header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 30px 0;

            .headerRight {
                min-width: 86px;
                margin-left: 5px;
                display: flex;

                @media (min-width: $breakpoint-sm) {
                    min-width: 162px;
                }

                .listView,
                .mapView {
                    display: inline-flex;
                    padding: 7px 9px 7px 14px;
                    line-height: 18px;
                    cursor: pointer;
                    border: 1px solid $color-switch-bg;
                    border-radius: 16px 0 0 16px;

                    @media (min-width: $breakpoint-sm) {
                        padding: 7px 15px;
                    }

                    > span {
                        display: none;

                        @media (min-width: $breakpoint-sm) {
                            display: block;
                        }
                    }

                    svg {
                        width: 18px;
                        height: 18px;
                        color: $color-primary;

                        @media (min-width: $breakpoint-sm) {
                            margin-right: 7px;
                        }
                    }

                    &.active {
                        background: $color-switch-bg;

                        svg {
                            color: $color-white;
                        }
                    }
                }

                .mapView {
                    padding: 7px 14px 7px 9px;
                    border-radius: 0 16px 16px 0;

                    @media (min-width: $breakpoint-sm) {
                        padding-left: 12px;
                    }
                }
            }
        }

      .headerLeft {
        margin-bottom: 0.25rem;
      }

        h2 {
            margin: 0;
            font-size: 18px;
            font-weight: 400;
            letter-spacing: -0.59px;
        }

        hr {
            margin-top: 50px;
        }
    }

    .listContainer,
    .mapContainer {
        &.hidden {
            height: 0;
            visibility: hidden;
        }

        .message {
            color: transparentize($color-text, 0.30);
            text-align: center;
        }
    }

    .mapContainer {
        width: 100%;
        height: 412px;
        margin-bottom: 10px;
        border-radius: 5px;

        .map {
            height: 412px;
            border-radius: 5px;
        }
    }

    .marker {
        display: flex;
        align-items: center;
        text-decoration: none;

        .markerIcon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 37px;
            height: 37px;
            color: $color-primary;
            background: $color-white;
            border-radius: 37px;
            transition: background 0.5s ease;

            svg {
                height: 15px;
            }
        }

        .markerText {
            display: inline-flex;
            width: auto;
            height: 24px;
            padding: 5px 12px;
            margin-left: 5px;
            font-family: $content-font-family;
            font-size: 14px;
            line-height: 14px;
            color: transparentize($color-white, 0.2);
            letter-spacing: -0.1px;
            background: $color-gray;
            border-radius: 24px;

            svg {
                width: 7px;
                height: 12px;
                margin: 1px 0 0 11px;
                color: $color-primary;
            }
        }

        &.active,
        &:hover {
            .markerIcon {
                color: $color-white;
                background: $color-primary;
            }

            .markerText {
                color: $color-white;

                svg {
                    color: $color-white;
                }
            }
        }
    }
</style>
